import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { loadTicketsByParent } from "../../service/ticket.service";
import { Card, CardContent, Divider, Stack, Typography } from "@mui/material";
import { SupportTicketForm } from "./SupportTicketForm";
import { useEffect, useMemo, useState } from "react";
import { SupportTicket } from "../../types/SupportTicket";
import { formatTime } from "../../utils/DateUtils";
import { useUserStore } from "../../store/user.store";

interface SupportViewFormProps {
    ticketId?: any,
    onClose?: () => void
}

export function SupportViewForm({ ticketId, onClose }: SupportViewFormProps) {
    const [dataToDisplay, setDataToDisplay] = useState<SupportTicket[]>([])

    const {data} = useQuery({
        queryKey: ["supportTickets", 'single', ticketId],
        refetchOnWindowFocus: false,
        queryFn: () => loadTicketsByParent(ticketId).then(r => r.data),
        placeholderData: keepPreviousData,
    });

    const {loadUser, getName} = useUserStore();
    useEffect(() => {
        setDataToDisplay(data || []);
        data?.forEach(d => loadUser(d.createdBy))
    }, [loadUser, data]);

    const metadata = useMemo(() => {
        if(!data || data.length === 0) {
            return null;
        }
        return data[0];
    }, [data])



    return <Stack gap={"15px"}>
        <Stack style={{width: '100%', maxWidth: 1200, margin: "0 auto" }} gap={"15px"}>
        {dataToDisplay.map((ticket, index) => (
            <Card key={ticket.id} variant="outlined">
                <CardContent style={{'paddingBottom': "15px"}}>
                    {index === 0 && (
                        <>
                            <Typography variant="h6" gutterBottom>
                                {ticket.title}
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                        </>
                    )}

                    <Typography variant="body1">
                        {ticket.content}
                    </Typography>

                    <Typography variant="caption" color="text.secondary">
                        Posted {formatTime(ticket.createdAt)} by <strong>{getName(ticket.createdBy)}</strong>
                    </Typography>
                </CardContent>
            </Card>
        ))}
    </Stack>
        {metadata && <SupportTicketForm
            margin={"0 auto 15px"}
            parent={metadata.parentId}
            hideTitle entityId={metadata.entityId}
            status={metadata.status}
            onSubmit={t => {
            if(t) {
                setDataToDisplay([...dataToDisplay, t]);
            } else {
                onClose && onClose();
            }
        }}/>}
    </Stack>
}